import {Component, Input} from "@angular/core";
import {Vendor, VendorType} from "fello-model";

@Component({
  selector: "lib-vendor-details",
  templateUrl: "./vendor-details.component.html",
  styleUrls: ["./vendor-details.component.scss"]
})
export class VendorDetailsComponent {
  @Input() vendor: Vendor;
  VendorType = VendorType;
}
